export const parseBillHTML = htmlString => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const data = {
    scan: [],
    procedure: [],
    consultation: [],
    pharmacy: [],
    injection: []
  };

  const table = doc.getElementById('myTable');
  if (!table) {
    return data;
  }

  const rows = table.querySelectorAll('tbody tr');

  rows.forEach(row => {
    const descriptionCell = row.cells[0];
    const remarksCell = row.cells[1];
    const amountCell = row.cells[2];

    if (descriptionCell && remarksCell && amountCell) {
      const descriptions = Array.from(descriptionCell.querySelectorAll("p:not([class*='hide'])"));
      const remarks = Array.from(remarksCell.querySelectorAll("p:not([class*='hide'])"));
      const amounts = Array.from(amountCell.querySelectorAll("p:not([class*='hide'])"));

      const processRow = (descP, index, type) => {
        const description = descP.textContent.trim();
        const remark = remarks[index] ? remarks[index].textContent.trim() : '';
        const amount = amounts[index] ? amounts[index].textContent.trim() : '';
        data[type].push({description, remark, amount});
      };

      descriptions.forEach((descP, index) => {
        const parentDiv = descP.closest('div');
        if (parentDiv) {
          const previousP = parentDiv.querySelector("p[class*='hide']");
          if (previousP) {
            const text = previousP.textContent.toLowerCase();
            if (text.includes('scan')) {
              processRow(descP, index, 'scan');
            } else if (text.includes('procedure')) {
              processRow(descP, index, 'procedure');
            } else if (text.includes('consultation')) {
              processRow(descP, index, 'consultation');
            } else if (text.includes('pharmacy')) {
              processRow(descP, index, 'pharmacy');
            } else if (text.includes('injection')) {
              processRow(descP, index, 'injection');
            }
          }
        }
      });
    }
  });

  return data;
};
